/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Issue_Title_PlaceholderInputs */

const en_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue title...`)
};

const fr_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre de l'incident...`)
};

const de_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel der Ausgabe...`)
};

const it_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo del problema...`)
};

const ru_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название выпуска...`)
};

const es_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título del número...`)
};

const zh_cn2_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题标题……`)
};

const ja_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題のタイトル...`)
};

const hi_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंक का शीर्षक...`)
};

const pt_pt2_manual_qc_issue_title_placeholder = /** @type {(inputs: Manual_Qc_Issue_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título da edição...`)
};

/**
* | output |
* | --- |
* | "Issue title..." |
*
* @param {Manual_Qc_Issue_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_issue_title_placeholder = /** @type {((inputs?: Manual_Qc_Issue_Title_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Issue_Title_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_issue_title_placeholder(inputs)
	if (locale === "de") return de_manual_qc_issue_title_placeholder(inputs)
	if (locale === "it") return it_manual_qc_issue_title_placeholder(inputs)
	if (locale === "ru") return ru_manual_qc_issue_title_placeholder(inputs)
	if (locale === "es") return es_manual_qc_issue_title_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_issue_title_placeholder(inputs)
	if (locale === "ja") return ja_manual_qc_issue_title_placeholder(inputs)
	if (locale === "hi") return hi_manual_qc_issue_title_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_issue_title_placeholder(inputs)
	return en_manual_qc_issue_title_placeholder(inputs)
});